import React from "react";
import { motion } from "framer-motion";

const LandingPageHeader = ({ icon: Icon, title, subtitle, center = false }) => {
  return (
    <div className={`mb-8 flex flex-col ${center ? "items-center text-center" : "items-start text-left"}`}>
      <motion.h2
        initial={{ opacity: 0, x: center ? 0 : -10, y: center ? -10 : 0 }}
        whileInView={{ opacity: 1, x: 0, y: 0 }}
        viewport={{ once: true }}
        className="text-3xl lg:text-4xl font-black flex items-center gap-3 text-slate-900 dark:text-white transition-colors"
      >
        {Icon && <Icon className="text-blue-600 dark:text-blue-400" size={28} />}
        {title}
      </motion.h2>
      
      {subtitle && (
        <p className={`text-slate-500 dark:text-slate-400 mt-1 text-[10px] uppercase tracking-[0.2em] font-bold ${center ? "max-w-xl" : "max-w-md"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default LandingPageHeader;